import { useState } from "react";
import { getDownloadCredentialRequest } from "src/services/admin/queries/credentials";

const useDowloadCredential = () => {
	const [loading, setLoading] = useState(false);

	const onDownload = (credential: string) => {
		setLoading(true);
		getDownloadCredentialRequest(credential).then((reponse: any) => {
			var file = window.URL.createObjectURL(reponse);
			let fileLink = document.createElement("a");
			fileLink.href = file;
			fileLink.download = credential;
			fileLink.click();
		});
	};

	return { onDownload, loading };
};

export default useDowloadCredential;
